import { render, staticRenderFns } from "./SearchBasic.vue?vue&type=template&id=f703a93e&scoped=true&"
import script from "./SearchBasic.vue?vue&type=script&lang=js&"
export * from "./SearchBasic.vue?vue&type=script&lang=js&"
import style0 from "./SearchBasic.vue?vue&type=style&index=0&id=f703a93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703a93e",
  null
  
)

export default component.exports